import React, { FC } from "react";

import Svg from "./Svg";
import colors from "../../utils/colorConstants";

interface Props {
  className?: string;
  width: string;
  height: string;
  strokeColor?: string;
}

const PlayIcon: FC<Props> = ({
  className,
  height = "1.5rem",
  strokeColor = colors.lapel,
  width = "1.5rem",
}) => (
  <Svg
    className={className}
    height={height}
    viewBox="0 0 24 24"
    width={width}
    title="play icon"
  >
    <path
      fill={strokeColor}
      d="M7 6.01l10.66 5.81L7 17.64V6.01zm0-1a1 1 0 00-1 1v11.63a1 1 0 001.48.88l10.66-5.82a1 1 0 000-1.76L7.48 5.13A1 1 0 007 5v.01z"
    />
  </Svg>
);

export default PlayIcon;
